import React, { FC, useState } from 'react';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { FilterAttributeGroup, AttributeFilterOptionTemplate } from 'store/category/types';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import setCategoryPageNrOperation from 'store/category/operation/setCategoryPageNrOperation';
import { setCategoryRefetchFlagAction } from 'store/category/slice';
import updateCategoryQueryStringOperation from 'store/category/operation/updateCategoryQueryStringOperation';
import { useHistory } from 'react-router';
import CheckBoxOptions from '../ItemsFilter/CheckBoxOptions/CheckBoxOptions';
import ColorOptions from '../ItemsFilter/ColorOptions/ColorOptions';
import styles from './Filter.module.scss';

export type FilterProps = {
  attribute: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterItem;
  index: number;
  filterAttributeGroup: FilterAttributeGroup;
  applyFiltersImmediately?: boolean;
};

const Filter: FC<FilterProps> = ({ attribute, filterAttributeGroup, index, applyFiltersImmediately }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [filterExpanded, setFilterExpanded] = useState(true);

  const textKeysForTypename: { [key: string]: string } = {
    Orientation: 'txt_orientation',
    ProductType: 'txt_product_type',
    color: 'txt_color',
  };

  const applyFilters = () => {
    if (!applyFiltersImmediately) return;
    dispatch(setCategoryPageNrOperation(1));
    dispatch(setCategoryRefetchFlagAction(true));
    dispatch(updateCategoryQueryStringOperation(history));
  };

  const txt_key = textKeysForTypename[attribute.typeName];

  return (
    <div className={styles.filter}>
      <div className={styles.filterHeading} onClick={() => setFilterExpanded(!filterExpanded)}>
        <OpText variant="body-large-bold" className={styles.filterName}>
          {t(txt_key)}
        </OpText>
        <OpIcon icon={filterExpanded ? 'caret-up' : 'caret-down'} size="x-small" />
      </div>
      <div className={cn(styles.options, { [styles.visible]: filterExpanded })}>
        {attribute.optionTemplate === AttributeFilterOptionTemplate.CheckBoxOption && (
          <CheckBoxOptions
            key={`pcbot${index}`}
            attribute={attribute}
            group={filterAttributeGroup}
            onClick={applyFilters}
          />
        )}

        {attribute.optionTemplate === AttributeFilterOptionTemplate.ColorOption && (
          <ColorOptions
            onClick={applyFilters}
            key={`cot_${index}`}
            attribute={attribute}
            group={filterAttributeGroup}
          />
        )}
      </div>
    </div>
  );
};

export default Filter;
